import Base from "@patternslib/patternslib/src/core/base";


export default Base.extend({
  name: 'gmap-autocomplete',
  trigger: '.pat-gmap-autocomplete',
  parser: 'mockup',

  fillInAddress: function() {
    // Get the place details from the autocomplete object.
    let self = this;
    const place = self.autocomplete.getPlace();
    let address = "";
    let postcode = "";

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    // place.address_components are google.maps.GeocoderAddressComponent objects
    // which are documented at http://goo.gle/3l5i5Mr
    for (const component of place.address_components) {
      // @ts-ignore remove once typings fixed
      const componentType = component.types[0];

      switch (componentType) {
        case "street_number": {
          address = `${component.long_name} ${address}`;
          break;
        }
        case "route": {
          address += component.short_name;
          break;
        }
        case "postal_code": {
          postcode = `${component.long_name}${postcode}`;
          break;
        }
        case "postal_code_suffix": {
          postcode = `${postcode}-${component.long_name}`;
          break;
        }
        case "locality":
          if (self.cityField){
            self.cityField.value = component.long_name;
          }
          break;
        case "administrative_area_level_2": {
          if (self.countyField){
            let val = component.short_name;
            if (val.endsWith(" County")){
              val = val.slice(0, -7);
            }
            self.countyField.value = val;
          }
          break;
        }
      }
    }
    self.addressField.value = address;
    self.postalField.value = postcode;
  },

  initAutocomplete: function (){
    let self = this;
    let prefix = self.options.fieldsPrefix;
    if (prefix === undefined){
      prefix = "";
    }
    self.addressField = self.el.querySelector("input#"+prefix+self.options.address);
    self.postalField = self.el.querySelector("input#"+prefix+self.options.zip);
    self.cityField = self.el.querySelector("input#"+prefix+self.options.city);
    self.countyField = self.el.querySelector("input#"+prefix+self.options.county);

    // Create the autocomplete object, restricting the search predictions to
    // addresses in the US and Canada.
    // You cannot restrict by state but a geofence can be used
    // https://stackoverflow.com/questions/26510984/use-componentrestrictions-to-just-one-state-in-google-maps
    self.autocomplete = new google.maps.places.Autocomplete(self.addressField, {
      componentRestrictions: { country: ["us"] },
      fields: ["address_components", "geometry"],
      types: ["address"],
    });
    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    self.autocomplete.addListener("place_changed", self.fillInAddress.bind(self));
  },

  loadScript: function(url, callback){
    // Adding the script tag to the head as suggested before
    var head = document.head;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    // Then bind the event to the callback function.
    // There are several events for cross browser compatibility.
    script.onreadystatechange = callback;
    script.onload = callback;

    // Fire the loading
    head.appendChild(script);
  },

  init: function () {
    let self = this;
    let google_maps_loaded = (google !== undefined && google.maps !== undefined);
    if (google_maps_loaded){
      self.initAutocomplete();
    }
    if (self.options.key !== undefined && !google_maps_loaded){
      self.loadScript("https://maps.googleapis.com/maps/api/js?key="+self.options.key+"&libraries=places", self.initAutocomplete.bind(self));
    }
  },
});
